import styled from '@emotion/styled';
import { css } from '@emotion/react';
import xw from 'xwind';

export const GridContainer = styled.section(
  xw`w-full pt-0 grid sm:py-14 justify-center`,
  css`
    display: grid;
    margin-top: 50px;
    margin-bottom: 50px;
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    grid-template-areas:
      'title'
      'social'
      'tldr'
      'comments';

    @media screen and (min-width: 640px) {
      max-width: 1064px;
      grid-template-columns: 1fr 24px 102px;
      grid-auto-rows: auto;
      grid-template-areas:
        ' title . .'
        ' tldr . social'
        ' comments . .';
    }
  `,
);

export const DiscussionTitle = styled.h1(
  { gridArea: 'title' },
  xw`font-pangram mb-10 text-2xl leading-10`,
  xw`sm[text-3xl leading-10]`,
  xw`lg[text-3xl leading-13]`,
);
